/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// import Blanca from '../../../common/components/images/blanca.png';
import Image from '../../../common/Image';
import { getSignedUrlValid, uploadFileUrl } from '../../../modules/sport/actions/reducerProfile';
import { ITeam } from '../../../modules/sport/interfaces/profile';

import TennisDefault from '../../components/images/tenis-default.jpg';

const Blanca = 'https://supermatch-uploads-dev.s3.amazonaws.com/3bb68419-cab1-4bbb-8096-fea665eb8575.jpeg';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const TeamBySport = (props): JSX.Element => {
    const dispatch = useDispatch();
    const { teamOri, iconSport, urlFile, setTeamsAux, teams, index, error } = props;
    const [team, setTeam] = useState<ITeam>(teamOri);
    const [colorBorder, setColorBorder] = useState<string>(teamOri.color || 'bg-gray-200');
    const [colorBorder2, setColorBorder2] = useState<string>(teamOri.color2 || 'bg-gray-200');
    const [upload, setUpload] = useState(false);
    const [loandingPhotoTeam, setLoandingPhotoTeam] = useState<string>('false');
    const [errorPhoto, setErrorPhoto] = useState<string | null>(null);
    //const colorBg = color ? 'bg-' + color : 'bg-gray-200';

    const genders = [
        { name: 'Masculino', value: 'MALE' },
        { name: 'Femenino', value: 'FEMALE' },
        { name: 'Mixto', value: 'MIXED' },
    ];

    const levels = {
        tenis: [
            { name: 'Cuarta', value: 'Cuarta' },
            { name: 'Tercera', value: 'Tercera' },
            { name: 'Segunda', value: 'Segunda' },
            { name: 'Primera', value: 'Primera' },
            { name: 'Honor', value: 'Honor' },
        ],
        futbol: [
            { name: 'Amateur', value: 'Amateur' },
            { name: 'Semi Pro', value: 'Semi Pro' },
            { name: 'Pro', value: 'Pro' },
        ],
        padel: [
            { name: '1ra Categoría', value: '1ra Categoría' },
            { name: '2da Categoría', value: '2da Categoría' },
            { name: '3ra Categoría', value: '3ra Categoría' },
            { name: '4ta Categoría', value: '4ta Categoría' },
            { name: '5ta Categoría', value: '5ta Categoría' },
            { name: '6ta Categoría', value: '6ta Categoría' },
        ],
        basquetbol: [
            { name: 'AmaRookie (Novato)', value: 'Rookie (Novato)' },
            { name: 'Semi Pro', value: 'Semi Pro' },
            { name: 'Pro', value: 'Pro' },
            { name: 'All star', value: 'All star' },
        ],
    };

    const colorName = {
        'bg-yellow-500': 'Amarillo',
        'bg-black': 'Negro',
        'bg-white': 'Blanco',
        'bg-red-600': 'Rojo',
        'bg-blue-600': 'Azul',
        'bg-green-600': 'Verde',
    };

    const handleOnColor = (value) => {
        console.log(value);
        setTeam({ ...team, color: value });
        setColorBorder(value);
    };

    const handleOnColor2 = (value) => {
        console.log(value);
        setTeam({ ...team, color2: value });
        setColorBorder2(value);
    };

    const handleReviewTeam = (e: any) => {
        e.preventDefault();
        //console.log(e.target.value);
        setTeam({ ...team, review: e.target.value });
    };

    const handleNameTeam = (e: any) => {
        e.preventDefault();
        setTeam({ ...team, name: e.target.value });
    };

    useEffect(() => {
        //console.log('useEffect team:', team);
        const teamsAux = teams;
        teamsAux[index] = team;
        // console.log('useEffect teamsAux interno:', teamsAux);
        setTeamsAux(teamsAux);
    }, [team]);

    const uploadPhoto = async ({ target }) => {
        setUpload(true);
        const file = target.files[0];
        handlerUploadFile(file, 'team');
    };

    const handlerUploadFile = async (file: any, type: string) => {
        setErrorPhoto(null);
        const name = file.name;
        const lastDot = name.lastIndexOf('.');
        const extFile = name.substring(lastDot + 1);
        if (
            extFile !== 'jpg' &&
            extFile !== 'png' &&
            extFile !== 'jpeg' &&
            extFile !== 'gif' &&
            extFile !== 'JPG' &&
            extFile !== 'PNG' &&
            extFile !== 'JPEG' &&
            extFile !== 'GIF'
        ) {
            setLoandingPhotoTeam('false');
            setErrorPhoto('Formato Invalido, formaro permitidos jpg, png, gif');
        } else {
            const options = {
                name: file?.name || '',
                fileType: '.' + extFile,
            };
            try {
                if (type === 'team') {
                    setLoandingPhotoTeam('true');
                }

                const dataSignedUrl: any = await dispatch(getSignedUrlValid(options));

                if (dataSignedUrl && dataSignedUrl.signedUrl) {
                    const statusUpload: any = await dispatch(
                        uploadFileUrl(dataSignedUrl.signedUrl, dataSignedUrl.contentType, file),
                    );
                    // console.log({ dataSignedUrl });
                    if (statusUpload === 'OK') {
                        setTeam({ ...team, photo: dataSignedUrl.key });

                        setErrorPhoto(null);
                        setLoandingPhotoTeam('false');
                    }
                } else {
                    setErrorPhoto('Error al subir archivo vuelva Intentar');
                }
            } catch (error) {
                //  console.log('desde del form error: ', { error });
                setErrorPhoto('Error al subir archivo vuelva Intentar');
            }
        }
    };

    const handleGenderTeam = (e: any) => {
        e.preventDefault();
        setTeam({ ...team, gender: e.target.value });
    };

    const handleLevelTeam = (e: any) => {
        e.preventDefault();
        setTeam({ ...team, level: e.target.value });
    };

    return (
        <>
            <div className={`flex w-full relative justify-center content-center   rounded-lg  bg-white  `} id="team">
                <div className={`w-full  items-center content-center`}>
                    <div
                        className={`flex w-full mt-4 md:mt-0 justify-center content-center py-2 rounded-lg bg-sm-blue-primary `}
                    >
                        <h1 className={`text-white font-semibold text-lg`}>{team.sportName}</h1>
                        <Image
                            className="absolute right-6 md:-right-3 top-1 md:-top-1 block w-auto cursor-pointer pl-4"
                            imgClassName="h-16"
                            src={iconSport}
                            alt="Deporte"
                            height={50}
                        />
                    </div>
                    <div className={`relative cursor-pointer flex p-2 justify-center items-center content-center`}>
                        <div
                            className={`flex mr-6 w-10 h-10 mx-1 shadow-profile ${colorBorder} rounded-full text-center justify-center content-center relative`}
                        >
                            {' '}
                            <p className="absolute w-20 z-30 top-12 font-bold text-xs text-white bg-sm-blue-primary p-1 rounded-md">
                                {colorName[colorBorder]}
                            </p>
                        </div>
                        <Image
                            className={`hover:bg-gray-100 hover:border-gray-300 rounded-full border-4 shadow-profile border-sm-blue-primary  p-2`}
                            src={
                                team.imagePath && !upload
                                    ? team.imagePath
                                    : upload
                                    ? urlFile && team.photo
                                        ? urlFile + team.photo
                                        : ''
                                    : team.sportSlug === 'tenis'
                                    ? TennisDefault
                                    : Blanca
                            }
                            alt={'team'}
                            height={150}
                            width={150}
                            imgClassName={`rounded-full`}
                        />
                        <div
                            className={`flex  ml-6 w-10 h-10 mx-1  shadow-profile ${colorBorder2} rounded-full text-center justify-center content-center relative`}
                        >
                            {' '}
                            <p className="absolute w-20 z-30 top-12 font-bold text-xs text-white bg-sm-blue-primary p-1 rounded-md  ">
                                {colorName[colorBorder2]}
                            </p>
                        </div>
                        <input
                            accept="image/*"
                            className={'opacity-0 h-44 w-44  absolute z-20 top-0 cursor-pointer'}
                            id="button-photo-capture"
                            onChange={uploadPhoto}
                            type="file"
                        />
                        {loandingPhotoTeam === 'true' ? (
                            <p className="absolute z-30 top-1/2 text-xs text-black">Cargando Logo...</p>
                        ) : (
                            <p className="absolute z-30 top-1/2 text-base text-black">
                                {team.imagePath ? '' : upload ? 'Foto Equipo' : 'Foto Equipo'}
                            </p>
                        )}
                        {errorPhoto && (
                            <p className="absolute z-30 top-1/2 text-sm text-red-400 text-center">{errorPhoto}</p>
                        )}
                    </div>
                    <div className="flex flex-col md:flex-row justify-center items-center content-center">
                        <div className="flex-col md:flex-row pt-2 w-full px-2">
                            <label className="relative text-gray-400 w-full focus-within:text-gray-600 block pt-2 mt-6 ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 pb-1 right-3"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                </svg>
                                {team.review && (
                                    <label
                                        htmlFor="review"
                                        className="pointer-events-none font-semibold  absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                    >
                                        Nombre del equipo
                                    </label>
                                )}
                                <textarea
                                    name="name"
                                    rows={6}
                                    id="name"
                                    className={`form-input p-4 border-2 rounded-xl border-gray-300 shadow-profile mb-2 py-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block pr-14 focus:outline-none ${
                                        error.name.hasError && 'ring-1 ring-red-500'
                                    }`}
                                    placeholder="Nombre de tu equipo"
                                    value={team.name}
                                    onChange={handleNameTeam}
                                />
                                {error.name.hasError && <p className="text-sm text-red-500">{error.name.message}</p>}
                            </label>
                        </div>
                        <div className="flex-col md:flex-row pt-2 w-full px-2">
                            <label className="relative text-gray-400 w-full focus-within:text-gray-600 block pt-2 mt-6 ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 pb-1 right-3"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                </svg>
                                {team.review && (
                                    <label
                                        htmlFor="review"
                                        className="pointer-events-none font-semibold  absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                    >
                                        Cuentanos de tu equipo
                                    </label>
                                )}
                                <textarea
                                    name="review"
                                    rows={6}
                                    id="review"
                                    className={`form-input p-4 border-2 rounded-xl border-gray-300 shadow-profile mb-2 py-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block pr-14 focus:outline-none ${
                                        error.review.hasError && 'ring-1 ring-red-500'
                                    }`}
                                    placeholder="Cuentanos de tu equipo"
                                    value={team.review}
                                    onChange={handleReviewTeam}
                                />
                                {error.review.hasError && (
                                    <p className="text-sm text-red-500">{error.review.message}</p>
                                )}
                            </label>
                        </div>
                        <div className="flex-col md:flex-row pt-2 w-full">
                            <div className="flex-col pt-4">
                                <label className="relative block">
                                    <label
                                        htmlFor="colorTeam"
                                        className="pointer-events-none w-full block text-center	text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                    >
                                        Color del equipo local
                                    </label>
                                    <fieldset
                                        className="space-x-1 w-full text-center justify-center content-center"
                                        id="colorTeam2"
                                    >
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor('bg-yellow-500')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-yellow-500 ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-yellow-500'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1 ${
                                                        team.color !== ''
                                                            ? team.color === 'bg-yellow-500'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3 ">
                                            <div
                                                onClick={() => handleOnColor('bg-black')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-black ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-black'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color !== ''
                                                            ? team.color === 'bg-black'
                                                                ? 'bg-white'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor('bg-white')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-white ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-white'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color !== ''
                                                            ? team.color === 'bg-white'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor('bg-red-600')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-red-600 ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-red-600'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color !== ''
                                                            ? team.color === 'bg-red-600'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        {/*<label className="inline-flex items-center mt-3">
                                        <div
                                            onClick={() => handleOnColor('bg-purple-600')}
                                            className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-purple-600 ${
                                                team.color !== ''
                                                    ? team.color === 'bg-purple-600'
                                                        ? 'border-black'
                                                        : ''
                                                    : ''
                                            } `}
                                        >
                                            {' '}
                                            <span
                                                className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-purple-600'
                                                            ? 'bg-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            ></span>
                                        </div>
                                            </label>*/}
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor('bg-blue-600')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-blue-600 ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-blue-600'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color !== ''
                                                            ? team.color === 'bg-blue-600'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor('bg-green-600')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-green-600 ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-green-600'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color !== ''
                                                            ? team.color === 'bg-green-600'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        {/*<label className="inline-flex items-center mt-3">
                                        <div
                                            onClick={() => handleOnColor('bg-yellow-600')}
                                            className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-yellow-600 ${
                                                team.color !== ''
                                                    ? team.color === 'bg-yellow-600'
                                                        ? 'border-black'
                                                        : ''
                                                    : ''
                                            } `}
                                        >
                                            {' '}
                                            <span
                                                className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                    team.color !== ''
                                                        ? team.color === 'bg-yellow-600'
                                                            ? 'bg-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            ></span>
                                        </div>
                                            </label>*/}
                                        {error.color.hasError && (
                                            <p className="text-sm text-red-500">{error.color.message}</p>
                                        )}
                                    </fieldset>
                                </label>
                                <label className="relative block mt-4">
                                    <label
                                        htmlFor="colorTeam2"
                                        className="pointer-events-none w-full block text-center text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                    >
                                        Color del equipo visitante
                                    </label>
                                    <fieldset
                                        className="space-x-1 w-full text-center justify-center content-center"
                                        id="colorTeam2"
                                    >
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor2('bg-yellow-500')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-yellow-500 ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-yellow-500'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1 ${
                                                        team.color2 !== ''
                                                            ? team.color2 === 'bg-yellow-500'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3 ">
                                            <div
                                                onClick={() => handleOnColor2('bg-black')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-black ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-black'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color2 !== ''
                                                            ? team.color2 === 'bg-black'
                                                                ? 'bg-white'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor2('bg-white')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-white ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-white'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color2 !== ''
                                                            ? team.color2 === 'bg-white'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor2('bg-red-600')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-red-600 ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-red-600'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color2 !== ''
                                                            ? team.color2 === 'bg-red-600'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        {/*<label className="inline-flex items-center mt-3">
                                        <div
                                            onClick={() => handleOnColor2('bg-purple-600')}
                                            className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-purple-600 ${
                                                team.color2 !== ''
                                                    ? team.color2 === 'bg-purple-600'
                                                        ? 'border-black'
                                                        : ''
                                                    : ''
                                            } `}
                                        >
                                            {' '}
                                            <span
                                                className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-purple-600'
                                                            ? 'bg-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            ></span>
                                        </div>
                                            </label>*/}
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor2('bg-blue-600')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-blue-600 ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-blue-600'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color2 !== ''
                                                            ? team.color2 === 'bg-blue-600'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        <label className="inline-flex items-center mt-3">
                                            <div
                                                onClick={() => handleOnColor2('bg-green-600')}
                                                className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-green-600 ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-green-600'
                                                            ? 'border-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            >
                                                {' '}
                                                <span
                                                    className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                        team.color2 !== ''
                                                            ? team.color2 === 'bg-green-600'
                                                                ? 'bg-black'
                                                                : ''
                                                            : ''
                                                    } `}
                                                ></span>
                                            </div>
                                        </label>
                                        {/*<label className="inline-flex items-center mt-3">
                                        <div
                                            onClick={() => handleOnColor2('bg-yellow-600')}
                                            className={`relative cursor-pointer ml-2 text-xs h-5 w-5 rounded-full border-2 p-2  bg-yellow-600 ${
                                                team.color2 !== ''
                                                    ? team.color2 === 'bg-yellow-600'
                                                        ? 'border-black'
                                                        : ''
                                                    : ''
                                            } `}
                                        >
                                            {' '}
                                            <span
                                                className={`absolute h-2 w-2 rounded-full mx-auto top-1 left-1  ${
                                                    team.color2 !== ''
                                                        ? team.color2 === 'bg-yellow-600'
                                                            ? 'bg-black'
                                                            : ''
                                                        : ''
                                                } `}
                                            ></span>
                                        </div>
                                            </label>*/}
                                        {error.color2.hasError && (
                                            <p className="text-sm text-red-500  text-center w-full">
                                                {error.color2.message}
                                            </p>
                                        )}
                                    </fieldset>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row justify-center items-center content-center ">
                        <div className="flex-col md:flex-row pt-2 w-full px-2">
                            <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                                <label
                                    htmlFor="gender"
                                    className="font-semibold  pl-1 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                >
                                    Sexo
                                </label>
                                <select
                                    className={`
                                        border-gray-300 w-full mb-2 py-3 p-4  h-14 bg-white border-2  rounded-xl text-left shadow-profile`}
                                    name="gender"
                                    value={team.gender}
                                    onChange={handleGenderTeam}
                                    disabled={genders && genders.length > 0 ? false : true}
                                >
                                    <option className="text-sm-gray-1" value="">
                                        Sexo
                                    </option>
                                    {genders &&
                                        genders.length > 0 &&
                                        genders.map((r, i) => (
                                            <option value={r.value} key={`gender-${i}`}>
                                                {r.name}
                                            </option>
                                        ))}
                                </select>
                                {error.gender.hasError && (
                                    <p className="text-sm text-red-500">{error.gender.message}</p>
                                )}
                            </label>
                        </div>
                        <div className="flex-col md:flex-row pt-2 w-full px-2">
                            <label className="relative text-gray-400 focus-within:text-gray-600 block pt-2 mt-4">
                                <label
                                    htmlFor="level"
                                    className="font-semibold pl-1 pointer-events-none absolute left-0 -top-3.5 text-sm-blue-primary text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-2 peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                                >
                                    Nivel
                                </label>
                                <select
                                    className={`
                                        border-gray-300 w-full mb-2 py-3 p-4  h-14 bg-white border-2  rounded-xl text-left shadow-profile`}
                                    name="level"
                                    id="level"
                                    value={team.level}
                                    onChange={handleLevelTeam}
                                    disabled={genders && genders.length > 0 ? false : true}
                                >
                                    <option className="text-sm-gray-1" value="">
                                        Nivel
                                    </option>
                                    {levels &&
                                        levels[teamOri.sportSlug] &&
                                        levels[teamOri.sportSlug].length > 0 &&
                                        levels[teamOri.sportSlug].map((r, i) => (
                                            <option value={r.value} key={`level-${i}`}>
                                                {r.name}
                                            </option>
                                        ))}
                                </select>
                                {error.level.hasError && <p className="text-sm text-red-500">{error.level.message}</p>}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TeamBySport;
